import { render, staticRenderFns } from "./DZ.vue?vue&type=template&id=2b584cc0&scoped=true"
import script from "./DZ.vue?vue&type=script&lang=js"
export * from "./DZ.vue?vue&type=script&lang=js"
import style0 from "./DZ.vue?vue&type=style&index=0&id=2b584cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b584cc0",
  null
  
)

export default component.exports